import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { images } from 'assets/images';
import { hideModal } from 'state/actions';
import { MODAL, COLOR } from 'config/constants';
import { HvModal, HvButton } from 'components';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    '@media (min-width: 767px)': {
      minWidth: 400,
    },
    padding: 20,
  },
  image: {
    width: 200,
    height: 'auto',
    marginBottom: 20,
  },
  title: {
    fontSize: 24,
    fontFamily: 'FordAntenna-Medium',
    marginBottom: 12,
    color: COLOR.GREEN,
  },
  description: {
    fontSize: 16,
    marginBottom: 16,
    lineHeight: 1.5,
  },
  countdown: {
    color: COLOR.DARK_GREY,
  },
  buttonContainer: {
    display: 'flex',
    gap: 16,
    width: '100%',
    justifyContent: 'center',
  },
});
interface Props {
  image: string;
  modalTitle?: string;
  description?: string;
  buttonText?: string;
  buttonAction?: () => void;
}

function SuccessModal({ image, modalTitle, description, buttonText, buttonAction }: Props) {
  const intl = useIntl();
  const styles = useStyles();
  const dispatch = useDispatch();
  const [countdown, setCountdown] = useState(5);

  const fmtSuccess = intl.formatMessage({ id: 'shooting.create.messages.success' });
  const fmtGoingBack = intl.formatMessage({ id: 'shooting.create.messages.goingBack' });
  const fmtSeconds = intl.formatMessage({ id: 'shooting.create.messages.seconds' });

  const onClose = () => {
    dispatch(hideModal(MODAL.SUCCESS));
    if (buttonAction) {
      buttonAction();
    }
  };

  // Auto-close modal after 5 seconds with countdown
  useEffect(() => {
    const countdownInterval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          if (buttonAction) {
            buttonAction();
          } else {
            onClose();
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(countdownInterval);
    };
  }, [buttonAction, onClose]);

  const buttons = (
    <div className={styles.buttonContainer}>
      <HvButton onClick={buttonAction}>{buttonText}</HvButton>
    </div>
  );

  return (
    <HvModal largerWidth title={modalTitle || ''} buttons={buttons} onClose={onClose}>
      <div className={styles.container}>
        <img src={images[image]} className={styles.image} alt={image} />
        <Typography className={styles.title}>{fmtSuccess}</Typography>
        <Typography className={styles.description}>{description}</Typography>
        <Typography className={styles.countdown}>
          {`${fmtGoingBack} ${countdown} ${fmtSeconds}`}
        </Typography>
      </div>
    </HvModal>
  );
}

export default SuccessModal;
